import { InjectionToken, Provider, Type } from '@angular/core';
import { Workflow } from './types/workflow';

export interface WorkflowTypeConfig {
  type: string;
  getRoute: (workflow: Workflow) => string[];
  getDetailComponent?: () => Promise<Type<unknown>>;
  getDetailInputs?: (workflow: Workflow) => Record<string, unknown>;
  getDetailProviders?: () => Provider[];
  viewModes?: ('kanban' | 'table')[];
}

export const SOFTLINE_CONFIG_WORKFLOW_TYPE = new InjectionToken<WorkflowTypeConfig>(
  'SOFTLINE_CONFIG_WORKFLOW_TYPE'
);

export const WORKFLOW_TAB_VALUE = '__workflow__' as const;
export type WorkflowTabValue = typeof WORKFLOW_TAB_VALUE;
